import React from "react";
import { CancelIcon } from "@components/Svg";
import FilterButton from "@components/UI/Buttons/FilterButton/FilterButton";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CompareIcon } from "@shared/ui/Icon/ui/Common/CompareIcon";
import { LocationIcon } from "@shared/ui/Icon/ui/Common/LocationIcon";
import { FILTER_LABELS } from "../constants";
import { FooterButtonsProps } from "./types";
import classes from "../MainFilter.module.scss";

export const FooterButtons: React.FC<FooterButtonsProps> = ({
    targetPath,
    btnLabel,
    previewQnt,
    isPreviewQntFetching,
    updatePreviewQntIsLoading,
    compareCount,
    showBadgeCount,
    onFilterSubmit,
    resetFilters,
    disableMapListMode,
    onRouterPush
}) => {
    return (
        <div className={classes.Footer}>
            <FilterButton
                title={FILTER_LABELS.SEARCH_MAP}
                type="primary-light"
                icon={<LocationIcon />}
                onClick={() => onRouterPush(`${targetPath}?mapView=true`)}
            />

            <FilterButton
                disabled={previewQnt === 0}
                title={btnLabel}
                loading={(isPreviewQntFetching || updatePreviewQntIsLoading) ?? false}
                type="primary"
                onClick={() => {
                    if (previewQnt === 0) return;
                    onFilterSubmit({});
                    disableMapListMode?.();
                }}
            />

            <div className={classes.CancelContainer}>
                <FilterButton
                    title={FILTER_LABELS.RESET_FILTERS}
                    type="cancel"
                    icon={<CancelIcon />}
                    onClick={resetFilters}
                />
            </div>

            <FilterButton
                title={FILTER_LABELS.COMPARE}
                type="light"
                icon={
                    <div className={classes.IconWrapper}>
                        <CompareIcon className={classes.CompareIcon} />
                        {showBadgeCount && (
                            <span className={classes.CompareIcon__badge}>{compareCount}</span>
                        )}
                    </div>
                }
                onClick={() => onRouterPush(RouterConfig.COMPARE)}
            />
        </div>
    );
};